import {
  colors,
  cornerRadius,
  elevations,
  spacing,
  styled,
} from "../../../../../../stitches.config";
import { Box, FlexRow } from "../../../../../Common/__styles__/Layout";

export const SubmissionsBuilderWrapper = styled("div", {
  background: colors.bgUiList,
  display: "grid",
  gridTemplateColumns: "516px 1fr",
  gap: "32px",
  paddingTop: "16px",
  paddingRight: "32px",
  width: "100%",
  envRelativeHeight: "calc(100vh - 64px)",
  alignItems: "stretch",
  justifyContent: "center",

  "@lgMax": {
    gridTemplateColumns: "1fr",
    paddingRight: "0px",
  },

  variants: {
    hasRightSidebar: {
      true: {
        gridTemplateColumns: "336px 1fr 336px",
        paddingRight: "0",

        "@lgMax": {
          gridTemplateColumns: "1fr",
          paddingRight: "0px",
        },
      },
    },
  },
});

export const ColumnWrapper = styled(Box, {
  display: "flex",
  flexDirection: "column",
  gap: spacing.l,
  overflowY: "auto",
  padding: spacing.l,
  boxShadow: elevations.md,
  borderRadius: cornerRadius.radiusLg,
  "@lgMax": {
    display: "none",
  },
  variants: {
    left: {
      true: {
        "@lgMax": {
          display: "flex",
        },
      },
    },
  },
});

export const MenuButtonsWrapper = styled(FlexRow, {
  gap: spacing.m,
  alignItems: "center",
});
